import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { CHANGE_TO_OB_MODAL_ID } from './constants';

export interface ChangeToOpenBankingButtonHook {
  onClick: () => void;
}

export default function useChangeToOpenBankingButton(): ChangeToOpenBankingButtonHook {
  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(
    () => showModal(CHANGE_TO_OB_MODAL_ID),
    [showModal],
  );

  return {
    onClick,
  };
}
